import React from 'react';
import { Box, Typography } from '@mui/material';
import { ScienceIcon } from '../../icons';
import { proDesignTokens } from '../common/ProDesignTokens';

/**
 * Shown in the Deep Dive tab when the user IS a member (has pdf_insights
 * access) but the edge function withheld the content (B1 per-account cap).
 *
 * The copy is deliberately generic and vague — it must NOT reveal the
 * rate-limit mechanism (the whole point of B1 is anti-exfiltration; telling a
 * scraper "you hit a limit, back off" defeats it), and no legitimate user
 * should ever see it. Just a neutral "temporarily unavailable" so the tab is
 * never blank.
 */
export default function DeepDiveRateLimited() {
  return (
    <Box sx={{ mb: { xs: 3, sm: 4 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <ScienceIcon sx={{ fontSize: '1.1rem', color: proDesignTokens.colors.pro.accent }} />
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: '1rem', sm: '1.05rem' } }}>
          Detailed Insights
        </Typography>
      </Box>
      <Box
        sx={{
          p: { xs: 2, sm: 2.5 },
          borderRadius: proDesignTokens.borderRadius.lg,
          border: `0.0625rem solid ${proDesignTokens.colors.pro.accentMedium}`,
          backgroundColor: 'rgba(46,125,50,0.04)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: '0.5rem',
        }}
      >
        <ScienceIcon sx={{ fontSize: '1.4rem', color: proDesignTokens.colors.neutral[400] }} />
        <Typography sx={{ fontSize: '0.95rem', fontWeight: 600, color: proDesignTokens.colors.neutral[800] }}>
          Temporarily unavailable
        </Typography>
        <Typography sx={{ fontSize: '0.85rem', color: proDesignTokens.colors.neutral[600], maxWidth: '24rem', lineHeight: 1.5 }}>
          Detailed insights aren't available right now. Please try again later.
        </Typography>
      </Box>
    </Box>
  );
}
